import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import camelCase from 'lodash/camelCase';

import { RoutesPath } from 'flow-components/routes/routes';

export const useBrowserTabTitle = (title?: string) => {
  const { t } = useTranslation('common');
  const location = useLocation();

  const routePathTitle = useMemo(() => {
    const entries = Object.entries(RoutesPath).find(([_, path]) =>
      location.pathname.includes(path)
    );

    if (entries) {
      const [key] = entries;

      return `${t(`labels.browserTabTitles.${camelCase(key)}`)} ${t(
        'labels.dashSuffix'
      )}`;
    }
    return '';
  }, [location.pathname, t]);

  useEffect(() => {
    const prevTitle = document.title;

    if (title) {
      document.title = title;
    } else {
      document.title = routePathTitle;
    }

    return () => {
      document.title = prevTitle;
    };
  }, [title, routePathTitle]);
};
